import { render, staticRenderFns } from "./intDetail.vue?vue&type=template&id=6eeb6cd8&scoped=true"
import script from "./intDetail.vue?vue&type=script&lang=js"
export * from "./intDetail.vue?vue&type=script&lang=js"
import style0 from "./intDetail.vue?vue&type=style&index=0&id=6eeb6cd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeb6cd8",
  null
  
)

export default component.exports